// extracted by mini-css-extract-plugin
export default {"wrapper":"BackButton_wrapper__FwAZ1","cookieAccepted":"BackButton_cookieAccepted__u-NW1","back":"BackButton_back__CVGVj"};